import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch, Route, Redirect, Link } from "react-router-dom";
import { useRecoilState } from "recoil";
import { userState } from "./stores/atoms";
import NotFound from "./pages/NotFound";
import Sidebar from "./components/common/Sidebar";
import Indicator from "./components/common/Indicator";
import AuthRoute from "./pages/AuthRoute";
import AddUser from "./components/auth/AddUser";
import AddUserDone from "./components/auth/AddUserDone";
import AddAdmin from "./components/admin/AddAdmin";
import Agreement from "./components/auth/Agreement";
import Register from "./components/auth/Register";
import AuthMail from "./components/auth/AuthMail";
import Login from "./components/auth/Login";
import FindPassword from "./components/auth/FindPassword";
import MyInfo from "./components/auth/MyInfo";
import Dashboard from "./components/dashboard/Dashboard";
import Employee from "./components/employee/Employee";
import EmployeeRegister from "./components/employee/EmployeeRegister";
import EmployeeDetail from "./components/employee/EmployeeDetail";
import Payment from "./components/payment/Payment";
import PaymentDetail from "./components/payment/PaymentDetail";
import Group from "./components/group/Group";
import GroupRegister from "./components/group/GroupRegister";
import GroupDetail from "./components/group/GroupDetail";
import GroupEmployee from "./components/group/GroupEmployee";
import UnpaidHistory from "./components/unpaid/UnpaidHistory";
import UseHistory from "./components/history/UseHistory";
import UseHistoryDetail from "./components/history/UseHistoryDetail";
import Admin from "./components/admin/Admin";
import RegisterSuccess from "./components/auth/RegisterSuccess";

function App() {
  const [user, setUser] = useRecoilState(userState);
  const isLogined = user !== null;
  const [headerShown, setHeaderShown] = useState(true);

  const logout = () => {
    alert("로그아웃 되었습니다.");
    setUser(null);
    sessionStorage.removeItem("user");
  };

  useEffect(() => {
    const user = sessionStorage.getItem("user");
    if (user) {
      setUser(JSON.parse(user));
    }
    if (user !== null || window.location.pathname.indexOf("add-user") > -1) {
      setHeaderShown(false);
    }
    // 로그인 되어있지 않으면 /login으로 redirect
    if (user === null) {
      return <Redirect to="/login" />;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogined]);

  return (
    <div className="App">
      <BrowserRouter>
        <div className="wrapper">
          {isLogined && <Sidebar logout={logout} />}
          <div className="content">
            <Link to="/" className="txt-decoration-none">
              {headerShown && (
                <img className="logo" src="/logo.png" alt="logo" />
              )}
            </Link>
            {isLogined && <Indicator />}
            <div className="display-flex justify-content-between"></div>
            <Switch>
              <AuthRoute
                exact
                isLogined={isLogined}
                path={["/", "/dashboard"]}
                render={(props) => <Dashboard {...props} />}
              />
              <Route
                path="/add-user/:id"
                render={props => <AddUser isLogined={isLogined} {...props} />} />
              <Route
                path="/add-user-done"
                render={props => <AddUserDone isLogined={isLogined} {...props} />} />
              <Route
                path="/add-admin/:id"
                render={props => <AddAdmin isLogined={isLogined} {...props} />} />
              <AuthRoute
                isLogined={isLogined}
                path="/my-info"
                render={(props) => <MyInfo {...props} />}
              />
              <Route
                path="/login"
                render={(props) => <Login isLogined={isLogined} {...props} />}
              />
              <Route
                path="/agreement"
                render={(props) => (
                  <Agreement isLogined={isLogined} {...props} />
                )}
              />
              <Route
                path="/register"
                render={(props) => (
                  <Register isLogined={isLogined} {...props} />
                )}
              />
              <Route
                path="/register-success"
                render={(props) => <RegisterSuccess {...props} />}
              />
              <Route
                path="/find-password"
                render={(props) => <FindPassword {...props} />}
              />
              <Route
                path="/auth-mail"
                render={(props) => <AuthMail {...props} />}
              />
              <AuthRoute
                path="/employee"
                isLogined={isLogined}
                render={(props) => <Employee {...props} />}
              />
              <AuthRoute
                path="/employee-register"
                isLogined={isLogined}
                render={(props) => <EmployeeRegister {...props} />}
              />
              <AuthRoute
                path="/employee-detail/:id"
                isLogined={isLogined}
                render={(props) => <EmployeeDetail {...props} />}
              />
              <AuthRoute
                path="/payment"
                isLogined={isLogined}
                render={(props) => <Payment {...props} />}
              />
              <AuthRoute
                path="/payment-detail/:payment/:id"
                isLogined={isLogined}
                component={PaymentDetail}
              />
              <AuthRoute
                path="/group"
                isLogined={isLogined}
                render={(props) => <Group {...props} />}
              />
              <AuthRoute
                path="/group-register"
                isLogined={isLogined}
                render={(props) => <GroupRegister {...props} />}
              />
              <AuthRoute
                path="/group-detail/:id"
                isLogined={isLogined}
                render={(props) => <GroupDetail {...props} />}
              />
              <AuthRoute
                path="/group-employee/:id"
                isLogined={isLogined}
                render={(props) => <GroupEmployee {...props} />}
              />
              <AuthRoute
                path="/unpaid-history"
                isLogined={isLogined}
                render={(props) => <UnpaidHistory {...props} />}
              />
              <AuthRoute
                path="/use-history"
                isLogined={isLogined}
                render={(props) => <UseHistory {...props} />}
              />
              <AuthRoute
                path="/use-history-detail/:id/:service_type"
                isLogined={isLogined}
                render={(props) => <UseHistoryDetail {...props} />}
              ></AuthRoute>
              <AuthRoute
                path="/admin"
                isLogined={isLogined}
                render={(props) => <Admin {...props} />}
              />
              <Route component={NotFound} />
            </Switch>
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
